import React, { useEffect, useRef, useState } from "react";
import Inputbox from "../../../Components/Inputbox";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  Deletecontact,
  DeleteIdentification,
  Fetchcardtype,
  Patientrequestupdates,
  uploadImage,
} from "../../../../api/helper";
import { ShowToast } from "../../../../helpers/ToastService";
import { DropDownManuCustom } from "../../../Components/DropDownButton";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import DeleteModal from "../../Components/DeleteModal";

const validationSchema = Yup.object().shape({
  TypeofID: Yup.string().required("Type of ID is required"),
  IdentificationNumber: Yup.string().required(
    "Identification Number is required"
  ),
  ExpirationDate: Yup.string().required("Expiration Date of ID is required"),
});

const ClientIdentification = ({ info, getDteails }) => {
  const [image, setImages] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [idtypedata, setidtypedata] = useState([]);
  const fileInputRef = useRef(null);
  const [ismodal, setismodal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState("");
  const [editmodal, seteditmodal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [confirmdeletemodal, setconfirmdeletemodal] = useState(false);
  const [deleteId, setdeleteId] = useState(null);

  const handleViewDocument = (imageUrl) => {
    setImageSrc(imageUrl);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setImageSrc("");
  };
  const clickImageData = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const imagePicker = async (event) => {
    const file = event.target.files[0];
    console.log(file, "====>file");
    if (file) {
      // console.log(file,'------->>file')
      const formData = new FormData();
      formData.append("images", file);
      try {
        const response = await uploadImage(formData);
        setImages(response.data.data[0].URL);
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreview(reader.result);
        };
        reader.readAsDataURL(file);
      } catch (error) {
        console.log(error, "===");
      }
    }
  };
  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data) => {
    if (!image) {
      ShowToast("Please upload image");
      return;
    }

    data.id = info?._id;

    const newIdentification = {
      IdentificationNumber: data.IdentificationNumber,
      ExpirationDate: data.ExpirationDate,
      TypeofID: data.TypeofID,
      UploadCopy: image,
    };

    try {
      if (isEditMode && editData) {
        const updatedIdentification = (info?.Identification || []).map((item) =>
          item._id === editData._id ? { ...item, ...newIdentification } : item
        );

        const formattedData = {
          id: data.id,
          Identification: updatedIdentification,
        };

        const response = await Patientrequestupdates(formattedData);
        ShowToast(response?.data?.message);
      } else {
        const formattedData = {
          id: data.id,
          Identification: [...(info?.Identification || []), newIdentification],
        };

        const response = await Patientrequestupdates(formattedData);
        ShowToast(response?.data?.message);
      }

      setismodal(false);
      seteditmodal(false);
      setIsEditMode(false);
      setEditData(null);
      setImages(null);
      reset();
      getDteails();
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const Getcardtype = async () => {
    const respo = await Fetchcardtype();
    // console.log(respo?.data?.data?.data,"datat====rewspo======")
    setidtypedata(respo?.data?.data?.data);
  };
  useEffect(() => {
    Getcardtype();
  }, []);

  const handleRemove = (id) => {
    setdeleteId(id);
    setconfirmdeletemodal(true);
  };

  const confirmDelete = async () => {
    setconfirmdeletemodal(false);
 
    const data = {
      identificationId: deleteId,
      id: info?._id,
    };
    try {
      const respo = await DeleteIdentification(data);
      ShowToast(respo?.data?.message);
      getDteails();
    } catch (error) {
      console.log(error);
    }
  };
  const Handleedit = (item) => {
    seteditmodal(true);
    setIsEditMode(true);
    setEditData(item);
    setImages(item.UploadCopy);

    reset({
      IdentificationNumber: item.IdentificationNumber,
      TypeofID: item.TypeofID,
      ExpirationDate: item.ExpirationDate?.split("T")[0],
    });
  };

  return (
    <div className="container_NotesTabScreen">
      <h1>Identification</h1>

      <button
        className="add-button_NotesTabScreen"
        style={{ float: "right", marginBottom: 10 }}
        onClick={() => {
          setismodal(true);
        }}
      >
        Add Identification
      </button>
      <table id="member-table">
        <thead>
          <tr>
            <th>Identification Number</th>
            <th>Type of ID</th>
            <th>Expiration Date</th>
            <th>Image</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {info?.Identification && info.Identification.length > 0 ? (
            info.Identification.map((contact) => {
              const today = new Date();
              today.setHours(0, 0, 0, 0);

              const expiration = new Date(contact.ExpirationDate);
              expiration.setHours(0, 0, 0, 0);

              const isExpired = expiration < today;

              return (
                <tr key={contact._id}>
                  <td>{contact.IdentificationNumber}</td>
                  <td>{contact.TypeofID}</td>
                  <td style={{ color: isExpired ? "red" : "inherit" }}>
                    {contact.ExpirationDate}
                  </td>
                  <td>
                    <button
                      onClick={() => handleViewDocument(contact.UploadCopy)}
                    >
                      View Document
                    </button>
                  </td>
                  <td className="custom-action-td">
                    <div className="custom-dropdown">
                      <button className="custom-action-button">
                        ⋮ Actions
                      </button>
                      <div className="custom-dropdown-menu">
                        <ul>
                          <li>
                            <button
                              className="custom-dropdown-item"
                              onClick={() => Handleedit(contact)}
                            >
                              Edit
                            </button>
                          </li>
                          <li>
                            <button
                              className="custom-dropdown-item"
                              onClick={() => handleRemove(contact._id)}
                            >
                              Delete
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: "left", padding: "10px" }}>
                No Identification Found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {ismodal && (
        <div className="modal_twooo" id="add-member-modal">
          <h1>Identification</h1>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <div style={{ width: "100%" }}>
                <Inputbox
                  label="Identification Number"
                  type="text"
                  placeholder="Enter Id Number"
                  name="IdentificationNumber"
                  register={register}
                />
                {errors.IdentificationNumber && (
                  <p style={{ color: "red", textAlign: "left", marginTop: 5 }}>
                    {errors.IdentificationNumber.message}
                  </p>
                )}
              </div>
              <div style={{ width: "40px" }} />
              <div style={{ width: "100%" }}>
                <DropDownManuCustom
                  label="Type of ID"
                  placeholder="Select option"
                  options={idtypedata}
                  name="TypeofID"
                  dropdownicon
                  register={register}
                  clearErrors={clearErrors}
                />
                {errors.TypeofID && (
                  <p style={{ color: "red", textAlign: "left", marginTop: 5 }}>
                    {errors.TypeofID.message}
                  </p>
                )}
              </div>
              <div style={{ width: "40px" }} />
              <div style={{ width: "100%" }}>
                <Inputbox
                  label="Expiration Date"
                  type="date"
                  placeholder=""
                  name="ExpirationDate"
                  register={register}
                />
                {errors.ExpirationDate && (
                  <p style={{ color: "red", textAlign: "left", marginTop: 5 }}>
                    {errors.ExpirationDate.message}
                  </p>
                )}
              </div>
              <div style={{ width: "40px" }} />

              <div style={{ width: "100%", marginTop: 10 }}>
                <label>{"Upload a Copy"}</label>
                <div
                  style={{
                    border: "1px solid grey",
                    width: "100%",
                    height: 46,
                    borderRadius: 5,
                    paddingLeft: 10,
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      clickImageData();
                    }}
                    style={{
                      border: "1px solid lightgrey",
                      borderRadius: 7,
                      color: "black",
                      fontSize: 14,
                      paddingLeft: 5,
                      paddingRight: 5,
                      cursor: "pointer",
                    }}
                  >
                    Choose File
                  </button>

                  <input
                    type="file"
                    accept="image/*"
                    ref={fileInputRef}
                    onChange={imagePicker}
                    style={{ display: "none" }}
                  />

                  <div style={{ marginLeft: 5 }}>
                    {image ? "Image Uploaded" : "No file chosen"}
                  </div>
                </div>
              </div>
            </div>
            <div className="client-history__buttons">
              <button
                className="client-history__button client-history__button--cancel"
                onClick={() => {
                  setismodal(false);
                }}
              >
                Cancel
              </button>
              <button
                className="client-history__button client-history__button--save"
                type="submit"
              >
                Save Changes
              </button>
            </div>
          </form>
        </div>
      )}
      {editmodal && (
        <div className="modal_twooo" id="add-member-modal">
          <h1>Edit Identification</h1>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <div style={{ width: "100%" }}>
                <Inputbox
                  label="Identification Number"
                  type="text"
                  placeholder="Enter Id Number"
                  name="IdentificationNumber"
                  register={register}
                />
                {errors.IdentificationNumber && (
                  <p style={{ color: "red", textAlign: "left", marginTop: 5 }}>
                    {errors.IdentificationNumber.message}
                  </p>
                )}
              </div>
              <div style={{ width: "40px" }} />
              <div style={{ width: "100%" }}>
                <DropDownManuCustom
                  label="Type of ID"
                  placeholder="Select option"
                  options={idtypedata}
                  name="TypeofID"
                  dropdownicon
                  register={register}
                  clearErrors={clearErrors}
                  defaultValue={editData?.TypeofID}
                />
                {errors.TypeofID && (
                  <p style={{ color: "red", textAlign: "left", marginTop: 5 }}>
                    {errors.TypeofID.message}
                  </p>
                )}
              </div>
              <div style={{ width: "40px" }} />
              <div style={{ width: "100%" }}>
                <Inputbox
                  label="Expiration Date"
                  type="date"
                  placeholder=""
                  name="ExpirationDate"
                  register={register}
                />
                {errors.ExpirationDate && (
                  <p style={{ color: "red", textAlign: "left", marginTop: 5 }}>
                    {errors.ExpirationDate.message}
                  </p>
                )}
              </div>
              <div style={{ width: "40px" }} />

              <div style={{ width: "100%", marginTop: 10 }}>
                <label>{"Upload a Copy"}</label>
                <div
                  style={{
                    border: "1px solid grey",
                    width: "100%",
                    height: 46,
                    borderRadius: 5,
                    paddingLeft: 10,
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      clickImageData();
                    }}
                    style={{
                      border: "1px solid lightgrey",
                      borderRadius: 7,
                      color: "black",
                      fontSize: 14,
                      paddingLeft: 5,
                      paddingRight: 5,
                      cursor: "pointer",
                    }}
                  >
                    Choose File
                  </button>

                  <input
                    type="file"
                    accept="image/*"
                    ref={fileInputRef}
                    onChange={imagePicker}
                    style={{ display: "none" }}
                  />

                  <div style={{ marginLeft: 5 }}>
                    {image ? "Image Uploaded" : "No file chosen"}
                  </div>
                </div>
              </div>
            </div>
            <div className="client-history__buttons">
              <button
                className="client-history__button client-history__button--cancel"
                onClick={() => {
                  seteditmodal(false);
                }}
              >
                Cancel
              </button>
              <button
                className="client-history__button client-history__button--save"
                type="submit"
              >
                Save Changes
              </button>
            </div>
          </form>
        </div>
      )}
      <Dialog
        open={isModalOpen}
        onClose={handleCloseModal}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Image</DialogTitle>
        <DialogContent>
          <img
            src={imageSrc}
            alt="Document"
            style={{ width: "100%", height: "70vh", objectFit: "contain" }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {confirmdeletemodal && (
              <DeleteModal
                name="Identification"
                onClose={() => setconfirmdeletemodal(false)}
                onConfirm={confirmDelete}
              />
            )}
    </div>
  );
};

export default ClientIdentification;
